import React from "react";

import { CircularProgress, Stack } from "@mui/material";

import { Heading } from "../../atoms/Typography/Heading/Heading";
import { SubHeader4 } from "../../atoms/Typography/SubHeader/SubHeader";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";

export const AuthWrap = ({
  isLoading,
  pageTitle,
  pageSubheading,
  pageTitlesGap,
  itemsAlightment,
  children,
  formWidth,
  marginLeft,
}) => {
  return (
    <Stack
      style={{
        padding: "42px 30px",
      }}
    >
      {isLoading ? (
        <FormItemsWrap
          gap={pageTitlesGap || "32px"}
          justifyContent={"space-around"}
          alignItems={"center"}
          width={formWidth || "409px"}
        >
          <FormItemsWrap alignItems={itemsAlightment} marginLeft={marginLeft}>
            <Heading text={"Loading"} />
          </FormItemsWrap>
          <CircularProgress />
        </FormItemsWrap>
      ) : (
        <FormItemsWrap
          gap={pageTitlesGap || "32px"}
          justifyContent={"space-around"}
          width={formWidth || "409px"}
          alignItems={itemsAlightment}
        >
          <FormItemsWrap marginLeft={marginLeft}>
            <Heading text={pageTitle} />
            <SubHeader4 text={pageSubheading} />
          </FormItemsWrap>
          {children}
        </FormItemsWrap>
      )}
    </Stack>
  );
};
